var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4ec88e04b10637ecec9472346304206e0140238a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app@coordinape"]={id:"4ec88e04b10637ecec9472346304206e0140238a"};
      